export class Player {
    constructor(
        id,
        age,
        country,
        name,
        number,
        position,
        showCount,
        team,
    ) {
        this.id = id;
        this.age = age;
        this.country = country;
        this.name = name;
        this.number = number;
        this.position = position;
        this.showCount = showCount;
        this.team = team;
        this.label = name;
    }
}